// Sugestão para domínio de e-mail digitado errado ("@icoud.com" -> "@icloud.com"). Só sugere, nunca bloqueia:
// domínios próprios (da academia, de empresa) continuam valendo.

const DOMINIOS_COMUNS = [
  "gmail.com",
  "hotmail.com",
  "hotmail.com.br",
  "outlook.com",
  "outlook.com.br",
  "live.com",
  "icloud.com",
  "me.com",
  "yahoo.com",
  "yahoo.com.br",
  "uol.com.br",
  "bol.com.br",
  "terra.com.br",
] as const;

/** Distância de edição com transposição (Damerau-Levenshtein restrita): "gmial" x "gmail" = 1. */
function distancia(a: string, b: string): number {
  const d: number[][] = Array.from({ length: a.length + 1 }, (_, i) =>
    Array.from({ length: b.length + 1 }, (_, j) => (i === 0 ? j : j === 0 ? i : 0)),
  );
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const custo = a[i - 1] === b[j - 1] ? 0 : 1;
      let v = Math.min(d[i - 1]![j]! + 1, d[i]![j - 1]! + 1, d[i - 1]![j - 1]! + custo);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, d[i - 2]![j - 2]! + 1);
      d[i]![j] = v;
    }
  }
  return d[a.length]![b.length]!;
}

/**
 * E-mail corrigido quando o domínio parece erro de digitação de um provedor comum; `null` quando está certo,
 * é desconhecido demais para palpitar ou ainda não tem domínio.
 */
export function sugerirCorrecaoEmail(email: string): string | null {
  const texto = email.trim().toLowerCase();
  const arroba = texto.lastIndexOf("@");
  if (arroba < 1) return null;
  const dominio = texto.slice(arroba + 1);
  if (dominio.length < 4 || !dominio.includes(".")) return null;
  if ((DOMINIOS_COMUNS as readonly string[]).includes(dominio)) return null;
  let melhor: { dominio: string; d: number } | null = null;
  for (const candidato of DOMINIOS_COMUNS) {
    const d = distancia(dominio, candidato);
    if (d <= 2 && (!melhor || d < melhor.d)) melhor = { dominio: candidato, d };
  }
  return melhor ? `${texto.slice(0, arroba)}@${melhor.dominio}` : null;
}
